﻿import { RESTError } from "../RESTError";
import { SetWaveBuoyExcursionAlarmRequest } from "./SetWaveBuoyExcursionAlarmRequest";

var BASE_URL = '/api/Alerts';

export function setWaveBuoyExcursionAlarm(req: SetWaveBuoyExcursionAlarmRequest, callback: (RESTError: RESTError) => any): void {
    $.ajax(BASE_URL + '/SetWaveBuoyExcursionAlarm', {
        cache: false,
        type: 'POST',
        data: req,
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function deleteWaveBuoyExcursionAlarm(stationId: string, sensorId: string, callback: (RESTError: RESTError) => any): void {
    $.ajax(BASE_URL + '/DeleteWaveBuoyExcursionAlarm', {
        cache: false,
        type: 'POST',
        data: {
            "StationId": stationId,
            "SensorId": sensorId,
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function setParameterAlert(_alert: ParameterRangeEmailAlert, callback: (RESTError: RESTError) => any): void {
    $.ajax(BASE_URL + '/SetParameterAlert', {
        cache: false,
        type: 'POST',
        data: _alert,
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function deleteParameterAlert(_alert: ParameterRangeEmailAlert, callback: (RESTError: RESTError) => any): void {
    $.ajax(BASE_URL + '/DeleteParameterAlert', {
        cache: false,
        type: 'POST',
        data: _alert,
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}